import React, { useState } from "react";
import { all_routes } from "../../../router/all_routes";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip, tooltipClasses } from "@mui/material";

import { getNavigationUrl } from "../../../../utils/helpers/setAndGetUrlParams";

import { ImAlarm } from "react-icons/im";
import SetReminderModal from "../../reminders/components/SetReminderModal";
import { useSelector } from "react-redux";
import { convertToUTCString } from "../../../../utils/helpers/helper";
import { useCallHandler } from "../../../../utils/hooks/useCallHandler";
import {
  CALLER,
  COMPANY_ADMIN,
  SUPER_ADMIN,
} from "../../../../core/data/constants/constant";
import { MODULES } from "../../../../core/data/constants/moduleConstants";
import SocialMediaIcons from "../../../../core/common/crmComponents/SocialMediaIcons";
import { useFunctionalityAccess } from "../../../../core/common/wrapper/HasFunctionalityAccess";
import DetailsNavigator from "../../../../core/common/crmComponents/DetailsNavigator";
import queryClient from "../../../../config/queryClient";
import { toast } from "react-toastify";
import { FaCopy } from "react-icons/fa";
import LeadApi from "../api/LeadApi";
import { Download, DownloadDone } from "@mui/icons-material";

const LeadDetailsHeader = ({ leadData: lead, view, setView }) => {
  const route = all_routes;

  const navigate = useNavigate();
  const { user } = useSelector((state) => state?.auth);
  const { mutate, isPending, isSuccess, isError } = useCallHandler(
    MODULES.LEADS,
    lead?._id
  );
  const [isOpenPostCallModal, setIsOpenPostCallModal] = useState(false);

  const openModal = () => setIsOpenPostCallModal(true);
  const closeModal = () => setIsOpenPostCallModal(false);

  const canSetReminder = useFunctionalityAccess("setReminder");
  const hasCallPermission = useFunctionalityAccess("CallPermission");
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadFinancialPdf = async () => {
    if (!lead?._id) return;
    try {
      setIsDownloading(true);
      const blob = await LeadApi.getFinencialPlanningPdfForEnrollment(
        lead.profilingForm
      );
      const url = window.URL.createObjectURL(
        new Blob([blob], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      const fileName = `financial-report-${
        lead?.fullName ? lead.fullName.replace(/\s+/g, "-") : lead._id
      }.pdf`;
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      toast.success("Download started");
    } catch (err) {
      console.error("Failed to download financial PDF", err);
      toast.error("Failed to download financial PDF. Please try again.");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="col-md-12">
      <div className="row mb-3">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="col-auto">
            <ul className="contact-breadcrumb">
              <li>
                <div
                  onClick={() => navigate(getNavigationUrl(route.enrollment))}
                  className="navigate-link"
                >
                  <i className="ti ti-arrow-narrow-left text-capitalize me-1" />
                  Enrollment
                </div>
              </li>
            </ul>
          </div>
          <div className="col-auto">
            <div className="d-flex gap-2 justify-content-center align-items-center">
              <div className="toggle-buttons-container">
                <div
                  className={`btn text-white text-capitalize`}
                  style={{
                    height: "36px",
                    backgroundColor: `${
                      lead?.status == "active"
                        ? "#28a745"
                        : lead?.status == "inactive"
                        ? "#dc3545"
                        : "#6c757d"
                    }`,
                    borderRadius: "5px",
                    padding: "6px 12px",
                    pointerEvents: "none",
                  }}
                >
                  {lead?.status}
                </div>
                <button
                  className={`btn ${
                    view === "overview" ? "btn-primary" : "btn-light"
                  }`}
                  onClick={() => setView("overview")} // Correctly handle view change
                >
                  Overview
                </button>
                <button
                  className={`btn ${
                    view === "profilingForm" ? "btn-primary" : "btn-light"
                  }`}
                  onClick={() => setView("profilingForm")} // Correctly handle view change
                >
                  Profiling Form
                </button>
                <button
                  className={`btn ${
                    view === "timeline" ? "btn-primary" : "btn-light"
                  }`}
                  onClick={handleDownloadFinancialPdf}
                  disabled={isDownloading}
                >
                  <Download />{" "}
                  {isDownloading
                    ? "Downloading..."
                    : "Download Financial Planning PDF"}
                </button>
              </div>
              {/* <DetailsNavigator module="" currentModuleId={lead?._id} /> */}
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body pb-2">
          <div className="d-flex align-items-start justify-content-between flex-wrap border-bottom mb-2">
            <div className="d-flex align-items-center gap-2 mb-1">
              <h5 className="text-capitalize">
                <span className="text-grey">Full Name:</span>
                <span className="ms-1">{lead?.fullName}</span>
              </h5>
              {lead?.enrolledOn && (
                <span className="fw-italic fw-semibold">
                  <em>(Enrolled on {convertToUTCString(lead?.enrolledOn)})</em>
                </span>
              )}
            </div>

            <div className="d-flex align-items-start justify-content-between gap-2 flex-wrap">
              <div className="contacts-action">
                <div
                  className="me-2 mb-2 d-flex justify-content-center align-items-center "
                  style={{
                    background: "#DEFDE0",
                    borderRadius: "5px",
                    width: "36px",
                    height: "36px",
                  }}
                >
                  <SocialMediaIcons
                    platform="whatsapp"
                    phoneNumber={`${lead?.mobile}`}
                  />
                </div>
                {/* {canSetReminder && (
                  <Tooltip placement="bottom" title="Set Reminder">
                    <Link
                      type="button"
                      className="btn-icon"
                      data-bs-toggle="modal"
                      data-bs-target="#setReminderModal"
                    >
                      <ImAlarm />
                    </Link>
                  </Tooltip>
                )} */}
                {/* <Tooltip placement="bottom" title="Edit Lead">
                  <Link
                    to={route.leadsDetails.replace(":id", `edit/${lead?._id}`)}
                    state={{ data: lead, from: "leadDetails" }}
                    className="btn-icon"
                  >
                    <i className="ti ti-edit-circle" />
                  </Link>
                </Tooltip>{" "}
                {canSetReminder && (
                  <SetReminderModal data={lead} module="lead" />
                )} */}
              </div>
            </div>
          </div>

          <div className="row gx-2 px-1">
            <div className="col-lg-4 col-md-6">
              {lead?.ofCompany?.name && (
                <p className="mb-2 text-capitalize">
                  <span className="text-grey fw-bold">Company:</span>
                  <span className="ms-1 text-break">
                    <i className="ti ti-building me-1 fs-6" />
                    {lead?.ofCompany?.name}
                  </span>
                </p>
              )}
              {lead?.address?.street &&
              lead?.address?.city &&
              lead?.address?.state &&
              lead?.address?.zipcode ? (
                <p className="text-capitalize">
                  <span className="text-grey fw-semibold">Address:</span>
                  <span className="ms-1">
                    <i className="ti ti-map-pin-pin me-1 fs-6" />
                    {`${lead?.address?.street} ${lead?.address?.city} ${lead?.address?.state} ${lead?.address?.zipcode}`}
                  </span>
                </p>
              ) : (
                <p className="text-capitalize">
                  <span className="text-grey fw-bold">City:</span>
                  {lead?.city ? (
                    <span className="ms-1 text-capitalize">
                      <i className="ti ti-map-pin-pin me-1 fs-6" />
                      {lead?.city || lead?.address?.city}
                    </span>
                  ) : (
                    <span className="ms-1">N/A</span>
                  )}
                </p>
              )}
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="d-flex align-items-start mb-2">
                <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                  <i className="ti ti-mail fs-6" />
                </span>
                <p className="text-break">{lead?.email || "N/A"}</p>
              </div>

              {lead?.mobile && (
                <div className="d-flex align-items-start">
                  {hasCallPermission && user?.agentId && user?.campaignName ? (
                    <Tooltip
                      placement="bottom"
                      title="Click To Call"
                      slotProps={{
                        popper: {
                          sx: {
                            [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                              {
                                marginTop: "0px", // Adjust this to reduce space
                                transform: "translateY(0px)",
                              },
                          },
                        },
                      }}
                    >
                      <button className="d-flex align-items-center nav-link border-0 bg-transparent">
                        <div className="p-0 flex-shrink-0 text-primary me-2 fs-5">
                          {isPending ? (
                            <i className="ti ti-loader spinner" />
                          ) : (
                            <i className="ti ti-phone " />
                          )}
                        </div>
                        <p className="mb-0">{lead?.mobile || "N/A"}</p>{" "}
                      </button>
                    </Tooltip>
                  ) : hasCallPermission ? (
                    <a
                      onClick={(e) => {
                        e.preventDefault();

                        openModal();
                        setTimeout(() => {
                          window.location.href = `tel:${lead?.mobile}`;
                        }, 500); // Delay to allow modal to open or animate
                      }}
                      className="d-flex align-items-center nav-link border-0 bg-transparent "
                    >
                      <div className="p-0 flex-shrink-0 text-primary me-2 fs-5">
                        <i className="ti ti-phone" />
                      </div>
                      <p className="mb-0">{lead?.mobile || "N/A"}</p>
                    </a>
                  ) : (
                    <p className="mb-0">{lead?.mobile || "N/A"}</p>
                  )}

                  <button
                    className="btn ms-4 btn-outline-dark btn-sm d-flex align-items-center"
                    onClick={() => {
                      navigator.clipboard
                        .writeText(`${lead?.mobile}`)
                        .then(() => {
                          toast.success("Copied Number To Clipborad");
                        })
                        .catch((err) => {
                          toast.error("Failed To Copy Link");
                        });
                    }}
                  >
                    <FaCopy className="fs-6 mx-1" /> Copy
                  </button>
                </div>
              )}
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="mb-2 d-flex align-items-center">
                <p className="mb-0">
                  <span className="fw-bold me-2">Description:</span>
                  <span>{lead?.description || "N/A"}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadDetailsHeader;
